exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.blame-commit-wrapper[data-v-4dbd4d5b]::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: var(--blame-indicator-top);\n  height: var(--blame-indicator-height);\n  width: 3px;\n  background-color: var(--blame-indicator-color);\n  pointer-events: none;\n}\n", ""]);

